<template>
  <div class="accountability-holder">
    <div class="container">
      <div class="row history-holder">

        <!--<div class="col-xxl-5 col-xl-6 h-100 d-none d-xl-block position-relative mb-4">
          <div id="img-holder" class="position-absolute"></div>  COMENTADO CONTABILIDADE  
           <div id="background-element" class="position-absolute"></div> 
        </div> --> 

        <div class="col col-xxl-7 text-center acc">
          <div class="non-semantic-protector" id="history-heading-holder">
           <!-- <h1 class="ribbon">  COMENTADO CONTABILIDADE
               <strong class="ribbon-content"> 
                 <span>CONHEÇA NOSSA CONTABILIDADE</span> 
              </strong> 
            </h1> 
            <p id="history-prologue">Empresa criada para ter mais proximidade com o cliente. <br>
              Seu problema é falta de comunicação e acompanhamento? <br>
              Estamos disponíveis a qualquer momento para melhor lhe orientar. <br>
              Vamos juntos escrever essa história. <br> <br>
            </p>
            <p class="history-bold">Aqui <b>CONTABILIZAMOS SUCESSO.</b></p> --> 
           </div>

            <div class="row cards-holder">
            <div class="col-6 col-lg-3 p-1">
               <!--<div id="card-fiscal" class="card services-card justify-content-center">  
                <h5>Fiscal</h5>  
              </div> -->
            </div> 
            <div class="col-6 col-lg-3 p-1">
             <!-- <div id="card-contabil" class="card services-card justify-content-center">
                <h5>Contábil</h5>
              </div> -->
            </div>
            <div class="col-6 col-lg-3 p-1">
             <!-- <div id="card-comercial" class="card services-card justify-content-center">
                <h5>Comercial e Societário</h5>
              </div> -->
            </div>
            <div class="col-6 col-lg-3 p-1">
            <!--  <div id="card-pessoal" class="card services-card justify-content-center">
                <h5>Setor de Pessoal</h5>
              </div> -->
            </div>
          </div>
          
          <!-- Ativar quando tiver o Site da Contabilidade -->
          <!-- <div class="w-100">
            <button type="button" class="btn" id="history-btn-first">Leia mais</button>
          </div> -->
          
        </div>

      </div>
    </div>
  </div>
</template>

<script scoped>

export default {
  name: 'SectionAccountability',
  components: {
  }
}
</script>

<style scoped>

.services-card {
  height: 200px;
  opacity: 0.8;

  border-radius: 20px;

  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);

  transition: filter 400ms ease-in-out;
}

.services-card:hover {
  filter: grayscale(0);
}

#card-fiscal {
  background-image: url("../assets/images/escala-justica.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

#card-contabil {
  background-image: url("../assets/images/conceito-contabilidade.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

#card-comercial {
  background-image: url("../assets/images/conceito-comercial.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

#card-pessoal {
  background-image: url("../assets/images/conceito-recursos-humanos.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.cards-holder {
  color: #fff;
}

#img-holder {
  margin-top: 10px;
  height: 583px;
  width: 400px;
  z-index: 2;

  border-radius: 10px;
  background-image: url("../assets/images/logo-contabilidade.png");
  background-size: 220px;
  background-position: 50% 50%;
  background-color: #323232;
  background-repeat: no-repeat;
}

#background-element {
  width: 400px;
  height: 583px;
  top: -10px;
  left: -10px;

  background: linear-gradient(90deg, rgba(92,107,167,0.6054796918767507) 0%, rgba(251,113,73,0.5970763305322129) 100%);
  opacity: 0.8;

  border-radius: 10px;
  z-index: 1;
}

.history-holder {
  font-family: Montserrat Bold;
  margin: 0 7%;
}

#history-prologue {
  font-size: 1.3rem;
  color: #242424;
  filter: drop-shadow(1px 1px rgba(122, 121, 121, 0.575));
  line-height: 95%;
  /* margin-bottom: 60px; */
  margin-bottom: 0;
}

#history-btn-first {
  background-image: linear-gradient(to right, #4258b1 0%, #eb5429  51%, #4258b1  100%);
  margin: 5% 5px 5px 0;
  transition: 0.5s;
  padding: 10px 30px;
  font-size: 14px;
  background-size: 200% auto;
  color: #fff;
  box-shadow: 0 0 5px rgba(238, 238, 238, 0.336);
  border-radius: 20px;
  font-family: Montserrat Regular;
}

.history-bold {
  font-size: 1.7rem;
  color: #242424;
  filter: drop-shadow(1px 1px rgba(122, 121, 121, 0.575));
  line-height: 95%;
  margin-bottom: 60px;
}

.history-bold b {
  color: #fb7149;
}

.ribbon-content span {
  filter: drop-shadow(1px 1px rgba(122, 121, 121, 0.575));
}

.ribbon {
  border-radius: 20px;
  padding: 30px;
  font-size: 30px;
  position: relative;
  background: #fb7049ec;
  
  color: #fff;
  margin-bottom: 70px;
}

.accountability-holder {
  padding: 0 0 0px 0;
}

.contact-icon {
  cursor: pointer;
  font-size: 40px;

  background: linear-gradient(to right, #4258B1 0%, #EB5429 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bi-youtube {
  font-size: 30px;
}

.bi-instagram {
  font-size: 25px;
}

.bi-facebook {
  font-size: 25px;
}

.ribbon {
  /* font-size: 2rem !important;
  width: 80%;

  position: relative;
  background: #fb7149;
  color: #fff;

  text-align: center;
  padding: 0.5em 2em;
  margin: 0 0 80px 50px; */
}
/* 
.ribbon .ribbon-content span {
  filter: drop-shadow(2px 2px rgba(122, 121, 121, 0.575));
}

.ribbon:before, .ribbon:after {
 content: "";
 position: absolute;
 display: block;
 bottom: -1em;
 border: 1.5em solid #fb7049d2;
 z-index: -1;
}

.ribbon:before {
 left: -2em;
 border-right-width: 1.5em;
 border-left-color:transparent; border-left-color:initial;
}

.non-semantic-protector { 
  position: relative;
  z-index: 1;
}

.ribbon:after {
  right: -2em;
  border-left-width: 1.5em;
  border-right-color:transparent; border-right-color:initial;
}

.ribbon .ribbon-content:before, .ribbon .ribbon-content:after {
 content: "";

  position: absolute;
  display: block;
  border-style: solid;
  border-color: #fc5c30 transparent transparent transparent;
  bottom: -1em;
}

.ribbon .ribbon-content:before {
 left: 0;
 border-width: 1em 0 0 1em;
}

.ribbon .ribbon-content:after {
 right: 0;
 border-width: 1em 1em 0 0;
} */

@media (max-width: 1400px) {
  .ribbon-content span {
    font-size: 25px;
  }
}

@media (max-width: 768px) {
  .ribbon-content span {
    font-size: 22px;
  }
}

</style>